import { footerRoutes, SiteFooterColumns, type FooterBuiltByConfig, type SiteLinkComponent } from "@lumora/ui";
import { Link } from "react-router-dom";
import { SITE_ROUTES } from "./routes.js";

const PERSONAL_SITE = "https://bahaa.lumorasites.com/";
const GITHUB = "https://github.com/bahaaaldin214";
const LINKEDIN = "https://www.linkedin.com/in/bahmohammad/";

const BUILT_BY: FooterBuiltByConfig = {
  title: "Built by",
  name: "Bahaa Mohammad",
  nameHref: PERSONAL_SITE,
  link: { label: "Portfolio", href: PERSONAL_SITE },
  links: [
    { label: "GitHub", href: GITHUB },
    { label: "LinkedIn", href: LINKEDIN },
  ],
};

const RouterLink = Link as unknown as SiteLinkComponent;

/** Lumora's own footer: shared columns (no stores: one location-less platform), registry routes, credit. */
export function SiteFooter() {
  return (
    <footer className="lm-footer">
      <div className="lm-container">
        <SiteFooterColumns routes={footerRoutes(SITE_ROUTES)} Link={RouterLink} lumora={BUILT_BY} />
      </div>
      <div className="lm-footer-legal">
        <div className="lm-container">
          <span className="lm-footer-logo">Lumora</span>
          <p className="lm-footer-blurb">One backend, many beautiful websites.</p>
          <p>&copy; {new Date().getFullYear()} Lumora. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
